import { useEffect } from 'react';
import {
  useDataIntegrationStepControls,
  type DataIntegrationStepControls,
} from 'src/features/Signup/contexts/DataIntegrationStepControlsContext';

/**
 * the sidebar/page controls for the currently rendered step route.
 * this preserves the current UX where the sidebar buttons trigger navigation,
 * while allowing each step to own the "what happens on Next/Back" logic.
 */
export function useRegisterDataIntegrationStepControls(
  controls: DataIntegrationStepControls,
) {
  const { setControls } = useDataIntegrationStepControls();

  useEffect(() => {
    setControls(controls);
  }, []);
}
